import React from 'react';
import { SiteMenuBarContext } from "../context/site-menu-bar-context";
import { classNames } from '@shapeable/utils';
var cls = classNames('site-menu-bar');
export var useSiteMenuBar = function () {
  var context = React.useContext(SiteMenuBarContext) || {};
  return {
    showShadow: context.showShadow === undefined ? true : context.showShadow,
    slideDownDuration: context.slideDownDuration === undefined ? 0.3 : context.slideDownDuration,
    boundary: context.boundary || 'content',
    delay: context.delay === undefined ? 200 : context.delay
  };
};